import React from "react";
import { memo } from "react";
import Modal from "../../../../../core/feedback/Modal.tsx";
import "./ModalFiltrosViagens.css";
import Separator from "../../../../../core/components/Separator.tsx";
import { motion } from "framer-motion";
import { SHADOWS } from "../../../../../core/shadows.ts";
import useIsScrolled from "../../../../../hooks/useIsScrolled.ts";
import ModalFiltroViagensHeader from "./components/ModalFiltroViagensHeader.tsx";
import ModalFiltroViagensContent from "./components/ModalFiltroViagensContent.tsx";
interface ModalFiltrosViagensProps {
	isOpen: boolean;
	onClose: () => void;
	buscarViagens: () => void;
	onClearFiltros: () => void;
	showDiariaExcedida?: boolean;
}

function ModalFiltrosViagens({
	isOpen,
	onClose,
	buscarViagens,
	onClearFiltros,
	showDiariaExcedida = true,
}: ModalFiltrosViagensProps) {
	const [isScrolled, isAtEnd, containerRef] = useIsScrolled();

	return (
		<Modal isOpen={isOpen} onClose={onClose} closeButton={false}>
			<motion.div
				onClick={(e) => e.stopPropagation()}
				initial={{ opacity: 0, y: 50 }}
				exit={{ opacity: 0, y: 50 }}
				animate={{
					opacity: 1,
					y: 0,
				}}
				transition={{ duration: 0.3 }}
				className="modal-filtros-viagens-container"
			>
				<ModalFiltroViagensHeader
					onClose={onClose}
					isScrolled={isScrolled}
					buscarViagens={buscarViagens}
				/>
				<ModalFiltroViagensContent
					showDiariaExcedida={showDiariaExcedida}
					scrollRef={containerRef}
				/>
				<motion.div
					animate={{
						boxShadow: isAtEnd ? "none" : SHADOWS.topLg.boxShadow,
					}}
					transition={{ duration: 0.3 }}
					className="modal-filtros-viagens-botoes-container"
				>
					<motion.button
						initial={{ backgroundColor: "#007bff" }}
						whileHover={{ backgroundColor: "#0056b3" }}
						whileTap={{ scale: 0.95 }}
						animate={{ backgroundColor: "#007bff" }}
						transition={{ duration: 0.2, ease: "easeInOut" }}
						onClick={() => buscarViagens()}
						className="modal-filtros-viagens-botao"
					>
						Filtrar
					</motion.button>
					<Separator size="lg" direction="horizontal" />
					<motion.button
						initial={{ backgroundColor: "#FF0000" }}
						whileHover={{ backgroundColor: "#640A0A" }}
						whileTap={{ scale: 0.95 }}
						animate={{ backgroundColor: "#FF0000" }}
						transition={{ duration: 0.2, ease: "easeInOut" }}
						onClick={onClearFiltros}
						className="modal-filtros-viagens-botao"
					>
						Limpar
					</motion.button>
				</motion.div>
			</motion.div>
		</Modal>
	);
}

export default memo(ModalFiltrosViagens);
